import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-skeleton-checkout',
  templateUrl: './skeleton-checkout.component.html',
  styleUrls: ['./skeleton-checkout.component.scss']
})
export class SkeletonCheckoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
